var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { withTheme } from "styled-components";
import { FormattedMessage } from "@irati/utils/lang";
import { addLeadingZeros } from "@irati/deals/helpers/deals/countdown";
import { Body, Label } from "@irati/ui/src/Typography";
import Flex from "@irati/ui/src/Flex";
import { StyledSpan } from "./styled";
var Countdown = /** @class */ (function (_super) {
    __extends(Countdown, _super);
    function Countdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Countdown.prototype.render = function () {
        var _a = this.props, days = _a.days, hours = _a.hours, min = _a.min, sec = _a.sec, theme = _a.theme;
        return (React.createElement(Flex, { justifyContent: "center", margin: theme.spacing.three + " auto" },
            React.createElement(StyledSpan, null,
                React.createElement(Body, { weight: "bold", textAlign: "center", marginBottom: 0 }, addLeadingZeros(days)),
                React.createElement(Label, null,
                    React.createElement(FormattedMessage, { id: "perks.redemptionEvents.countdown.days.label", values: { days: days } }))),
            React.createElement(StyledSpan, null,
                React.createElement(Body, { weight: "bold", textAlign: "center", marginBottom: 0 }, addLeadingZeros(hours)),
                React.createElement(Label, null,
                    React.createElement(FormattedMessage, { id: "perks.redemptionEvents.countdown.hours.label", values: { hours: hours } }))),
            React.createElement(StyledSpan, null,
                React.createElement(Body, { weight: "bold", textAlign: "center", marginBottom: 0 }, addLeadingZeros(min)),
                React.createElement(Label, null,
                    React.createElement(FormattedMessage, { id: "perks.redemptionEvents.countdown.minutes.label", values: { min: min } }))),
            React.createElement(StyledSpan, null,
                React.createElement(Body, { weight: "bold", textAlign: "center", marginBottom: 0 }, addLeadingZeros(sec)),
                React.createElement(Label, null,
                    React.createElement(FormattedMessage, { id: "perks.redemptionEvents.countdown.seconds.label", values: { sec: sec } })))));
    };
    return Countdown;
}(PureComponent));
export default withTheme(Countdown);
